import React from "react";
import type { SpecialDay } from "../api/types";
import { fmtDayWithWeekday, multiplierText } from "../utils/seasonText";

/** Days that pay more. Renders nothing when there are none. */
const SpecialDays: React.FC<{ days: SpecialDay[] }> = ({ days }) => {
  if (!days || days.length === 0) return null;
  return (
    <section className="gm-panel gm-panel--pink" aria-label="Special days">
      <h2 className="gm-panel__title">Special days</h2>
      <ul className="gm-special">
        {days.map((d) => (
          <li key={d.dayKey}>
            {fmtDayWithWeekday(d.dayKey)}
            {d.label ? `, ${d.label}` : ""}: <span className="gm-special__mult">{multiplierText(d.multiplier)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default SpecialDays;
